import { Button } from 'components/Button';
import { TextInput } from 'components/Inputs/TextInput';
import { useTutorUserRegistration } from 'context';
import { useDisclose } from 'hooks/utilHooks';
import React from 'react';
import { emailValidator, requiredMessage } from 'schemas/validators';

import { Grid, Link, Typography } from '@mui/material';

import { EmailValidationInput } from './EmailValidationInput';

interface Props {}

export const TutorEmailValidationForm: React.FC<Props> = ({ children }) => {
  const { isOpen, onOpen, onClose } = useDisclose();

  const {
    loading,
    getEmailValidationToken,
    handlePrevious,
    finishWithoutPlan,
    continueToPayment,
  } = useTutorUserRegistration();

  return (
    <Grid p={2} container spacing={2} justifyContent="center">
      <Grid item container xs={12} md={6} spacing={2} justifyContent="center">
        <EmailValidationInput />

        <Grid item container xs={12} md={12} spacing={1} mt={4}>
          <Grid item xs={12} md={12}>
            <Typography
              color="#757575"
              fontSize={16}
              fontWeight={400}
              textAlign="center"
            >
              Seu endereço de e-mail está correto?
            </Typography>
          </Grid>

          <Grid item xs={12} md={12}>
            <TextInput
              required
              name="email"
              id="email"
              label=""
              onBlur={onClose}
              rules={{
                required: requiredMessage('E-mail'),
                validate: emailValidator,
              }}
              disabled={!isOpen || loading}
              InputProps={{
                endAdornment: (
                  <Link
                    underline="none"
                    onClick={onOpen}
                    sx={{ cursor: 'pointer' }}
                  >
                    Editar
                  </Link>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} md={12} container justifyContent="center">
            <Link
              underline="none"
              onClick={getEmailValidationToken}
              sx={{ cursor: 'pointer' }}
            >
              Reenviar código
            </Link>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        mt={6}
        xs={12}
        container
        item
        spacing={2}
        justifyContent="space-between"
        alignItems="flex-end"
      >
        <Grid item>
          <Button onClick={handlePrevious} disabled={loading}>
            VOLTAR
          </Button>
        </Grid>

        <Grid
          xs={9}
          container
          item
          justifyContent="flex-end"
          alignItems="flex-end"
          spacing={2}
        >
          <Grid item>
            <Button onClick={finishWithoutPlan} disabled={loading}>
              FINALIZAR CADASTRO
            </Button>
          </Grid>

          <Grid item>
            <Button onClick={continueToPayment} disabled={loading}>
              IR PARA PAGAMENTO
            </Button>
          </Grid>
        </Grid>

        {children}
      </Grid>
    </Grid>
  );
};
